import { RouteLocationNormalized, NavigationGuardNext, NavigationGuard } from 'vue-router';
import { useUserStore } from '@/store/user.ts';
import { storeToRefs } from 'pinia';
import { useAccountantInfoStore } from '@/store/useAccountantInfoStore.ts';

export const handleDashboardNavigation: NavigationGuard = (to: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const userStore = useUserStore();
  const { isAccountantRole, isManagerRole } = storeToRefs(userStore);
  const accountantInfoStore = useAccountantInfoStore();
  const { isAccountantChiefRole, isAccountantUserRole } = storeToRefs(accountantInfoStore);

  if (isManagerRole.value && to.name !== 'Companies') {
    next({ name: 'Companies' });
    return;
  }

  if (isAccountantRole.value) {
    if (isAccountantChiefRole.value && to.name !== 'AccountantChiefDashboard') {
      next({ name: 'AccountantChiefDashboard' });
      return;
    }
    if (isAccountantUserRole.value && to.name !== 'AccountantUserDashboard') {
      next({ name: 'AccountantUserDashboard' });
      return;
    }
  }

  next();
};

export const handleSettingsNavigation: NavigationGuard = (to: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const userStore = useUserStore();
  const { isManagerRole } = storeToRefs(userStore);

  if (isManagerRole.value && to.name === 'SettingsAccountPage') {
    next({ name: 'Companies' });
    return;
  }

  next();
};
